import Loaders from '../Loaders/Loaders'
import { Route, Routes } from 'react-router-dom'
import { ReactElement, Suspense, lazy } from 'react'

const Hospitals = lazy(() => import('../../features/Hospitals/Hospitals'))
const PatientVideo = lazy(
  () => import('../../features/PatientVideo/PatientVideo')
)
const ProrithmVitals = lazy(
  () => import('../../features/Prorithm/ProrithmVitals/ProrithmVitals')
)
const ProrithmDashboard = lazy(
  () => import('../../features/Prorithm/ProrithmDashboard/ProrithmDashboard')
)

const withSuspense = (Component: React.ElementType): ReactElement => (
  <Suspense fallback={<Loaders />}>
    <Component />
  </Suspense>
)

const Navigator = (): ReactElement => {
  return (
    <Routes>
      <Route path='/' element={withSuspense(Hospitals)} />
      <Route
        path='/prorithm/dashboard'
        element={withSuspense(ProrithmDashboard)}
      />
      <Route path='/prorithm/vitals' element={withSuspense(ProrithmVitals)} />
      <Route path='/videoCall' element={withSuspense(PatientVideo)} />
    </Routes>
  )
}

export default Navigator
